// import planets from './images/planets.png'
import ecomm from './images/ecomm.png'
import markdown from './images/markdown.png'
import pomodoro from './images/pomodoro.png'
import memorygame from './images/memorygame.png'
import coderecur from './images/coderecur.png'
import brainwave from './images/brainwave.png'

export default [
  {
    id: 1,
    title: 'Shoply E-commerce MERN web-app',
    skills: ' React, Redux, Express JS,Mongo DB',
    image: ecomm,
    url: 'https://mern-ecommerce-build-1.onrender.com',
    github: 'https://github.com/kinghennry/MERN-ECOMMERCE-BUILD',
  },
  {
    id: 2,
    title: 'Coderecur dev blog web-app',
    skills: ' React, Redux, Express JS,Mongo DB',
    image: coderecur,
    url: 'https://coderecur.onrender.com',
    github: 'https://github.com/kinghennry/coderecur-mern',
  },
  {
    id: 3,
    title: 'Insane Brainwave Gaming Landing Page with Slick Animations ',
    skills: 'React, Gsap',
    image: brainwave,
    url: 'https://brainwavegsap.netlify.app',
    github: 'https://github.com/kinghennry/Brainwave-Landing-Page',
  },
  {
    id: 4,
    title: 'Markdown web-app',
    skills: 'React, Javascript',
    image: markdown,
    url: 'https://markdoown-app.netlify.app',
    github: 'https://github.com/kinghennry/Markdown',
  },
  {
    id: 5,
    title: 'Insane Pomodoro timer web-app',
    skills: 'React, Javascript',
    image: pomodoro,
    url: 'https://pomdoro-app.netlify.app/',
    github: 'https://github.com/kinghennry/Pomdoro',
  },
  {
    id: 6,
    title: 'Cool memory-game web-app',
    skills: 'React, Javascript',
    image: memorygame,
    url: 'https://memory-gaame.netlify.app/',
    github: 'https://github.com/kinghennry/Memory-Game',
  },
]
